import {createStyles, Theme} from '@material-ui/core'

const edfImportType = (theme: Theme) =>
  createStyles({
    listSquareContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
    },
    squareIcon: {
      color: '#0cc7c7',
    },
    listTitle: {
      fontSize: 18,
      fontWeight: 700,
      color: '#333',
    },
    listSubTitle: {
      fontSize: 16,
      color: '#333',
    },
    listMeasurement: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
    },
    selectInput: {
      width: 200,
      height: 40,
    },
    radioWrap: {
      display: 'flex',
      flexDirection: 'row',
      alignContent: 'center',
      alignItems: 'center',
      justifyContent: 'space-between',
      '& label > span': {
        marginRight: 70,
        color: '#555555',
        fontSize: 13,
      },
      '& label > span > span > div > .MuiSvgIcon-fontSizeSmall': {
        fontSize: 17,
      },
    },
    radioText: {
      color: '#555555',
      fontSize: 13,
    },
    line: {
      color: '#fafafa',
      backgroundColor: '#fafafa',
      margin: '5px 0',
    },
    packageContainer: {
      display: 'flex',
    },
    buttonWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 100,
      marginTop: 20,
    },
    container: {
      '& > .MuiDialog-container > .MuiPaper-root': {
        [theme.breakpoints.up('xs')]: {
          minWidth: 300,
        },
        [theme.breakpoints.up('sm')]: {
          minWidth: 500,
        },
        [theme.breakpoints.up('md')]: {
          minWidth: 650,
        },
        [theme.breakpoints.up('lg')]: {
          minWidth: 500,
        },
      },
    },
    contentContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      height: 300,
      background: 'white',
      padding: 20,
    },
    listCircleContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      listStyleType: 'disc',
      paddingLeft: 20,
    },
    errorText: {
      color: '#d03c35',
      fontWeight: 700,
    },
  })

export default edfImportType
